import { useCallback, useEffect, useState } from "react";
import NotificationService from '../../services/Notifications';

export default function useNotifications({ status = 'unread' }) {
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((notification) => {
    if (notification) {
      // push
      setTotal((p) => p + 1);
      setNotifications((p) => [...p, notification]);
    }
  }, []);

  const removeNotification = useCallback(async (id) => {
    try {
      await NotificationService.readOne(id);
      setTotal((p) => p - 1);
      setNotifications((p) => p.filter((n) => n.id !== id));
    } catch (err) {
      console.log(err);
      // TO-DO Remove this
      setTotal((p) => p - 1);
      setNotifications((p) => p.filter((n) => n.id !== id));
    }
  }, []);

  const clearAll = useCallback(async () => {
    try {
      await NotificationService.readAll();
      setTotal(0);
      setNotifications([]);
    } catch (err) {
      console.log(err);
      // TO-DO Remove this
      setTotal(0);
      setNotifications([]);
    }
  }, []);

  const _fetch = async () => {
    if ((notifications.length && total >= notifications.length) || loading) {
      return;
    }

    setLoading(true);

    try {
      const _res = await NotificationService.get({ status });
      if (_res.data) {
        setTotal((p) => _res.data.total);
        setNotifications((p) => [...p, ..._res.data.data]);
        setLoading(false);
        return;
      }
      setLoading(false);

    } catch (err) {
      setLoading(false);
      setTotal(0);
      setNotifications([]);
    }
  }

  useEffect(() => {
    _fetch();
  }, []);

  const _notifications = notifications
    .sort((a, b) => b.createdAt - a.createdAt);

  return {
    total,
    loading,
    notifications,
    _notifications,
    _fetch,
    removeNotification,
    addNotification,
    clearAll,
  };
}
